import { Injectable } from '@angular/core';
import { ValidatorFn, FormGroup, ValidationErrors, AbstractControl, FormArray } from '@angular/forms';
import { SeedNeedsFormModel, ExperimentDesignFormModel, PollinationPreferenceGroupFormModel } from '../../services/request-form.service';
import { asEnumerable } from 'linq-es2015';

@Injectable()
export class ExperimentDesignFormValidatorsService {

  constructor() { }

  public plantingInstructionsValidator(numberOfEuids: number): ValidatorFn {
    return (treatmentGroup: FormGroup) => {
      const errors: ValidationErrors = {};
      const numberToPots = treatmentGroup.get('numberToPots');
      const numberToHarvest = treatmentGroup.get('numberToHarvest');

      if (numberOfEuids < numberToPots.value) {
        errors.numberToPots = {
          max: numberOfEuids,
        };
      }

      if (numberToPots && numberToPots.value < numberToHarvest.value) {
        errors.numberToHarvest = {
          max: numberToPots.value,
        };
      }
      return Object.keys(errors).length ? errors : null;
    };
  }

  public atLeastOneActiveOrAdjuvantValidator(): ValidatorFn {
    return function (control: AbstractControl): { [key: string]: any } | null {
      const actives = control.get('actives') as FormArray;
      const adjuvants = control.get('adjuvants') as FormArray;

      let hasValidActive = false;
      let hasValidAdjuvant = false;

      if (actives && actives.controls && actives.controls.length > 0) {
        for (let i = 0; i < actives.controls.length; i++) {
          if (actives.controls[i].valid) {
            hasValidActive = true;
            break;
          }
        }
      }

      if (adjuvants && adjuvants.controls && adjuvants.controls.length > 0) {
        for (let i = 0; i < adjuvants.controls.length; i++) {
          if (adjuvants.controls[i].valid) {
            hasValidAdjuvant = true;
            break;
          }
        }
      }
      if (hasValidActive || hasValidAdjuvant) {
        return null;
      }

      return { noActiveOrAdjuvant: true };
    };
  }

  public seedNeedsValidator(): ValidatorFn {
    return (group: FormGroup) => {
      const design = <ExperimentDesignFormModel>group.value;

      if (design.seedNeeds && design.seedNeeds.length > 0) {
        return null;
      } else {
        return {
          invalidSeedNeeds: {
            isError: true
          }
        };
      }
    }
  }

  public seedCountValidator(): ValidatorFn {
    return (group: FormGroup): ValidationErrors => {
      const seedNeedsEntry = <SeedNeedsFormModel>group.value;
      const sumAcrossTreatments = asEnumerable(seedNeedsEntry.treatments).Select(t => t.seedCount).Sum();

      if (sumAcrossTreatments !== seedNeedsEntry.numberOfSeeds) {
        return {
          seedCountMismatch: {
            isError: true
          }
        };
      } else {
        return null;
      }
    }
  }

  public pollinationPreferenceGroupValidator(): ValidatorFn {
    return (group: FormGroup) => {
      const preferenceGroup = <PollinationPreferenceGroupFormModel>group.value;

      if (preferenceGroup.items && preferenceGroup.items.length > 0) {
        return null;
      } else {
        return {
          emptyPreferenceGroup: {
            isError: true
          }
        };
      }
    }
  }
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/request-creation/experiment-design/experiment-design-form/experiment-design-form-validators.service.ts